/**
 * planContext — maps a resolved entitlement `plan_group` to a short,
 * customer-facing plan label used in the dashboard breadcrumb / top-left
 * page context (e.g. "Overview · Free Weekly" / "概要・無料週次プラン").
 *
 * The label MUST reflect the real resolved plan group from
 * `/api/entitlements/me` (the same source `useEntitlements()` reads), never
 * a weak profile field like `company_name` or `account_type` alone — that
 * was the P0 escalation vector closed earlier.
 */

const PLAN_GROUP_LABELS = {
  PERSONAL_WEEKLY_FREE: { en: 'Free Weekly', ja: '無料週次プラン' },
  PERSONAL_PREMIUM: { en: 'Personal Premium', ja: '個人プレミアム' },
  BUSINESS_SUITE: { en: 'Business Suite', ja: 'ビジネススイート' },
  GOVT_MILITARY_SUITE: { en: 'Government & Public-Sector Suite', ja: '官公庁・公共部門スイート' },
};

/**
 * Return the bilingual plan label for a plan group, or null when the plan
 * group is unknown / not yet resolved (so callers can hide the context
 * rather than render a misleading default).
 */
export function planContextLabel(planGroup, ja) {
  const entry = PLAN_GROUP_LABELS[planGroup];
  if (!entry) return null;
  return ja ? entry.ja : entry.en;
}

export { PLAN_GROUP_LABELS };
